import React from 'react'
import Error from './components/Error'

function NotFound() {
		return (
			<div>
				<Error />
				</div>
		)
}

export default NotFound